import React from 'react';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import "../../container/home/Home.css";
import firebase from "../../lib/firebase";
import sanitizeHtml from "sanitize-html";
var Autolinker = require( 'autolinker' );
class Home extends React.Component {
    constructor(Props){
        super(Props);
        this.state = {
            list:[]
        }
        firebase.database().ref('/home').once('value').then(function(sp){
            var list = [];
            sp.forEach(function(v){
                list.push(Object.assign({}, v.val(), {key:v.key}));
            });
            this.setState({list:list});
        }.bind(this));
    }

    render() {
        let list = this.state.list.map(function(v, i){
            let div = this.state.list.length === i+1 ? '' : <Divider/>;
            return (
                <div>
                    <ListItem
                        href={'/'+v.key}
                        key={v.key}
                        primaryText={v.title}
                        secondaryText={
                            <p dangerouslySetInnerHTML={{__html: sanitizeHtml(Autolinker.link(v.description), {
                                    allowedTags: ['a' ],
                                    allowedAttributes: {
                                        'a': [ 'href', 'target' ]
                                    }
                                })}}/>
                        }
                    />
                    {div}
                </div>
            );
        }.bind(this));
        return (
            <div id="Home">
                <h1>yah.ac</h1>
                <List id="list">
                    {list}
                    {/*<Divider inset={true}/>*/}
                </List>
            </div>

        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/container/home/Home.js